/* istanbul ignore file */
import { Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { DOWNLOAD_ARTIFACT } from 'domain/shared/artifact';
import { AttachmentsListField } from 'domain/shared/artifact/field';
import { useAuthorization } from 'framework/authorization';
import { ShowPageLayoutWithoutMenu } from 'framework/ui/layout';

const ArtifactHeader = () => {
  return (
    <Typography variant="h1" color="brand">
      Artifact
    </Typography>
  );
};

const ShowArtifactPage = () => {
  const { id = '' } = useParams<Dictionary<string>>();
  const { isGranted } = useAuthorization();
  const isDownloadAvailable = isGranted(DOWNLOAD_ARTIFACT);

  return (
    <ShowPageLayoutWithoutMenu entityHeader={<ArtifactHeader />}>
      <AttachmentsListField label="" value={[id]} isDownloadAvailable={isDownloadAvailable} />
    </ShowPageLayoutWithoutMenu>
  );
};

export default ShowArtifactPage;
